import { Centrifuge, type Subscription } from 'centrifuge';

export class RealTimeService {
  private static instance: RealTimeService | null = null;
  private static centrifugeInstance: Centrifuge | null = null;
  private static subscriptions: Map<string, Subscription> = new Map();

  private constructor() {}

  static getInstance(): RealTimeService {
    if (!RealTimeService.instance) {
      RealTimeService.instance = new RealTimeService();
    }
    return RealTimeService.instance;
  }

  connect(
    url: string,
    token: string,
    options?: {
      getToken?: () => Promise<string>;
      onConnected?: () => void;
      onDisconnected?: () => void;
    }
  ): void {
    if (RealTimeService.centrifugeInstance) {
      this.disconnect();
    }

    RealTimeService.centrifugeInstance = new Centrifuge(
      `${url}/connection/websocket`,
      {
        token,
        ...(options?.getToken && { getToken: options.getToken }),
      }
    );

    RealTimeService.centrifugeInstance.on('connected', (ctx) => {
      console.log('RealTimeService connected.', { clientID: ctx.client });
      options?.onConnected?.();
    });

    RealTimeService.centrifugeInstance.on('disconnected', (ctx) => {
      console.log('RealTimeService disconnected.', { reason: ctx.reason });
      options?.onDisconnected?.();
    });

    RealTimeService.centrifugeInstance.on('connecting', (ctx) => {
      console.log('RealTimeService connecting.', {
        code: ctx.code,
        reason: ctx.reason,
      });
    });

    RealTimeService.centrifugeInstance.on('error', (ctx) => {
      console.error('RealTimeService error.', ctx);
    });

    RealTimeService.centrifugeInstance.connect();
  }

  disconnect(): void {
    if (!RealTimeService.centrifugeInstance) return;

    RealTimeService.subscriptions.forEach((sub) => {
      sub.removeAllListeners();
    });
    RealTimeService.subscriptions.clear();

    RealTimeService.centrifugeInstance.removeAllListeners();
    RealTimeService.centrifugeInstance.disconnect();
    RealTimeService.centrifugeInstance = null;
  }

  subscribe(channel: string, onMessage: (data: unknown) => void): void {
    if (
      !RealTimeService.centrifugeInstance ||
      RealTimeService.subscriptions.has(channel)
    ) {
      return;
    }

    const sub = RealTimeService.centrifugeInstance.newSubscription(channel);

    sub.on('publication', (ctx) => {
      console.log(`[RealTime] ${channel}`, ctx.data);
      onMessage(ctx.data);
    });

    sub.on('error', (errCtx) => {
      console.error(`[RealTime] Subscription error on ${channel}`, errCtx);
    });

    sub.subscribe();
    RealTimeService.subscriptions.set(channel, sub);
  }

  unsubscribe(channel: string): void {
    const sub = RealTimeService.subscriptions.get(channel);
    if (!sub) return;

    sub.unsubscribe();
    sub.removeAllListeners();
    RealTimeService.centrifugeInstance?.removeSubscription(sub);
    RealTimeService.subscriptions.delete(channel);
  }
}
